"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var CustomPagination = function (props) {
    var _a, _b, _c, _d, _e;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var previousPage = function () {
        var _a;
        if (((_a = props.pagination) === null || _a === void 0 ? void 0 : _a.current_page) > 1) {
            props.setPageHandler(props.pagination.current_page - 1);
        }
    };
    var nextPage = function () {
        var _a, _b;
        if (((_a = props.pagination) === null || _a === void 0 ? void 0 : _a.current_page) < ((_b = props.pagination) === null || _b === void 0 ? void 0 : _b.last_page)) {
            props.setPageHandler(props.pagination.current_page + 1);
        }
    };
    return (react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center", style: { marginTop: "20px" } },
        react_1.default.createElement(q_play_components_1.Button, { style: { marginRight: "20px" }, text: t("Previous"), variant: "secondary", disabled: !(((_a = props.pagination) === null || _a === void 0 ? void 0 : _a.current_page) > 1), onClick: previousPage }),
        react_1.default.createElement("span", null,
            t("Page"),
            " ", (_b = props.pagination) === null || _b === void 0 ? void 0 :
            _b.current_page,
            " ",
            t("of"),
            " ", (_c = props.pagination) === null || _c === void 0 ? void 0 :
            _c.last_page),
        react_1.default.createElement(q_play_components_1.Button, { style: { marginLeft: "20px" }, text: t("Next"), variant: "secondary", disabled: !(((_d = props.pagination) === null || _d === void 0 ? void 0 : _d.current_page) < ((_e = props.pagination) === null || _e === void 0 ? void 0 : _e.last_page)), onClick: nextPage })));
};
exports.default = CustomPagination;
